export default "__VITE_ASSET__d3bcd919__"